module.exports = __webpack_public_path__ + "img/Wattens2.d51a64f5.jpg";